<template>
  <pagefra>
    <div
      class="lift container"
      v-loading.fullscreen.lock="fullLoading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
    >
      <panel type="toolbar">
        <div class="toolbar">
          <el-form
            class="toolbar-form"
            :inline="true"
            v-model="form"
            label-width
          >
            <el-form-item :label="$l('所属城市')">
              <el-input
                v-model="form.city"
                :placeholder="$l('所属城市')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('地盘名称')">
              <el-input
                v-model="form.domainName"
                :placeholder="$l('地盘名称')"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item :label="$l('作业时间')">
                            <el-date-picker v-model="planStartTimeValues" type="daterange" :range-separator="$l('至')"
                                :start-placeholder="$l('开始时间')" :end-placeholder="$l('结束时间')"
                                :picker-options="pickerOptions"></el-date-picker>
                        </el-form-item> -->
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
          <div class="toolbar-btn">
            <!-- <el-button round type="primary" icon="el-icon-download" @click="showQRCode(null)"
                            v-if="hasPermission('批量生成二维码')">
                            批量生成二维码</el-button> -->
          </div>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="tableE"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            height="100%"
            v-loading.lock="loading"
            :data="tableData"
            @selection-change="selectChange"
            style="width: 100%; z-index: 1000"
          >
            <!-- <el-table-column type="selection" width="55"></el-table-column> -->
            <el-table-column
              type="index"
              :label="$l('序号')"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('城市')"
              prop="city"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('地盘名称')"
              prop="domainName"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('报告详情')"
              min-width="100"
              header-align="center"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <div class="btns">
                  <svgicon
                    name="ribao"
                    :title="$l('日报')"
                    v-if="hasPermission('日报')"
                    @click="handleWeeklyOrMonthly(0, scope.row)"
                  ></svgicon>
                  <svgicon
                    name="zhoubao"
                    :title="$l('周报')"
                    v-if="hasPermission('周报')"
                    @click="handleWeeklyOrMonthly(1, scope.row)"
                  >
                  </svgicon>
                  <svgicon
                    name="yuebao"
                    :title="$l('月报')"
                    v-if="hasPermission('月报')"
                    @click="handleWeeklyOrMonthly(2, scope.row)"
                  >
                  </svgicon>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>
      <el-dialog
        :title="
          reportType == 1
            ? $l('查看周报')
            : reportType == 2
            ? $l('查看月报')
            : $l('查看日报')
        "
        :visible.sync="weeklyVisible"
        width="20%"
      >
        <el-date-picker
          style="width: 100%"
          value-format="yyyy-MM-dd"
          v-model="weeklyMonthlyValue"
          :type="reportType == 1 ? 'week' : reportType == 2 ? 'month' : 'date'"
          :format="
            reportType == 1
              ? weeklyMonthly
              : reportType == 2
              ? 'yyyy年MM月'
              : 'yyyy年MM月dd日'
          "
          :placeholder="
            reportType == 1
              ? $l('选择周')
              : reportType == 2
              ? $l('选择月')
              : $l('选择日期')
          "
        >
        </el-date-picker>
        <div slot="footer" class="dialog-footer">
          <el-button @click="weeklyVisible = false"
            >{{ $l("取 消") }}
          </el-button>
          <el-button type="primary" @click="clickViewWeekly"
            >{{ $l("查看") }}
          </el-button>
        </div>
      </el-dialog>
    </div>
  </pagefra>
</template>

<script>
import panel from "@/components/panel.vue";
import breadcrumb from "@/components/breadcrumb.vue";
import global from "@/mixins/global.js";
import dayjs from "dayjs";
export default {
  name: "domainReport",
  mixins: [global],
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    panel,
    breadcrumb,
  },
  data() {
    return {
      weeklyVisible: false,
      reportType: 0,
      weeklyMonthlyValue: "",
      row: {},
      date: "",
      form: {
        city: "",
        domainName: "",
        jobNum: "",
        registerCode: "",
        adminName: "",
        buildingName: "",
        dataPermissionList: [],
      },
      tableData: [],
      // planStartTimeValues: [],
      loading: false,
      fullLoading: false,
      pickerOptions: {
        disabledDate: (time) => {
          if (time) {
            return time.getTime() > new Date().getTime();
          }
        },
      },
      selectedList: [], //选中的行集合
    };
  },
  computed: {
    weeklyMonthly() {
      let end = dayjs(this.weeklyMonthlyValue)
        .add(6, "day")
        .format("YYYY年MM月DD日");
      return `${dayjs(this.weeklyMonthlyValue).format(
        "YYYY年MM月DD日"
      )} 至 ${end}`;
    },
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    search() {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    initData() {
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      this.form.pageName = "lift";
      this.tableData = [];
      this.loading = true;
      // if (this.planStartTimeValues && this.planStartTimeValues.length == 2) {
      //     this.form.startConfirmTime = this.$common.formatDate(this.planStartTimeValues[0]);
      //     this.form.endConfirmTime = this.$common.formatDate(this.planStartTimeValues[1]);
      // } else {
      //     this.form.startConfirmTime = "";
      //     this.form.endConfirmTime = "";
      // }
      this.$http
        .post(this.$apiConfig.get_elevator_domain_list, this.form)
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            result.data.result = result.data.result.map((item) => {
              item.confirmTime = this.$common.formatDate(item.confirmTime);
              return { ...item };
            });
            this.tableData = result.data.result;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    handleReportInfo(row) {
      if (row.elevatorType == "扶梯") {
        return this.message(1, "扶梯暂未上线！");
      }
      this.$router.push({
        path: "/report/elevatorDaily",
        query: {
          reportId: row.reportId,
          jobNum: row.jobNum,
          confirmTime: row.confirmTime || this.$common.formatDate(new Date()),
        },
      });
    },
    selectChange(selection) {
      this.selectedList = selection;
    },
    handleWeeklyOrMonthly(type, row) {
      this.reportType = type;
      this.row = row;
      const firstDayOfWeek =
        type == 1
          ? dayjs().startOf("week").add(1, "day").format("YYYY-MM-DD")
          : type == 2
          ? dayjs().format("YYYY-MM-01")
          : dayjs().format("YYYY-MM-DD");
      this.weeklyMonthlyValue = firstDayOfWeek;
      this.weeklyVisible = true;
    },
    clickViewWeekly() {
      let end =
        this.reportType == 1
          ? dayjs(this.weeklyMonthlyValue).add(6, "day").format("YYYY-MM-DD")
          : this.reportType == 2
          ? dayjs(this.weeklyMonthlyValue).endOf("month").format("YYYY-MM-DD")
          : " ";
      const query = {
        reportType: this.reportType,
        domainId: this.row.domainId,
        startTime: this.weeklyMonthlyValue,
        endTime: end,
      };
      this.weeklyVisible = false;
      this.$router.push({
        path:
          this.reportType == 1
            ? "/report/domainWeekly"
            : this.reportType == 2
            ? "/report/domainMonthly"
            : "/report/daily",
        query,
      });
    },
  },
  mounted() {
    // this.planStartTimeValues = [new Date(), new Date()];
    if (this.loaded) {
      this.initData();
    }
  },
  activated() {
    this.$refs.tableE.doLayout();
  },
};
</script>
<style lang="scss" scoped>
.lift {
  /deep/ .el-radio-button__inner {
    padding: 0px 15px;
    margin: 9px 0;
    border-top: 0;
    border-bottom: 0;
  }

  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    border-color: $--border-color-base;
    box-shadow: none;
    background-color: transparent;
    color: $--color-primary;
  }

  /deep/ .el-radio-button:first-child .el-radio-button__inner {
    border-left: 0;
  }

  /deep/ .el-radio-button:last-child .el-radio-button__inner {
    border-right: 0;
  }

  .dialog-form {
    .el-input,
    .el-select,
    .el-textarea {
      width: 400px;
    }
  }

  .qrcode {
    /deep/ .el-dialog__body {
      padding: 30px 20px 0px 20px;
    }
  }
}

.btns {
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    margin: 0 10px;
    width: 20px;
    height: 20px;
    cursor: pointer;
    fill: #df4545;
  }
}
</style>
